import { useEffect, useState } from 'react';
import MaintenanceService from '@src/services/MaintenanceService';
import maintenanceManager, { MaintenanceState } from '@src/utils/maintenanceManager';

interface MaintenanceHookState extends MaintenanceState {
  isChecking: boolean;
}

export default function useMaintenanceCheck(): MaintenanceHookState {
  const [maintenanceState, setMaintenanceState] = useState<MaintenanceState>(
    maintenanceManager.getState(),
  );
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const unsubscribe = maintenanceManager.subscribe(setMaintenanceState);

    MaintenanceService.checkAndApply({ failOpen: true }).finally(() => {
      if (!cancelled) setIsChecking(false);
    });

    return () => {
      cancelled = true;
      unsubscribe();
    };
  }, []);

  useEffect(() => {
    if (isChecking || !maintenanceState.isUnderMaintenance) return;

    let isPolling = false;
    const pollSilently = async () => {
      if (isPolling) return;

      isPolling = true;
      try {
        await MaintenanceService.checkAndApply();
      } finally {
        isPolling = false;
      }
    };

    const interval = setInterval(() => {
      pollSilently();
    }, MaintenanceService.POLL_INTERVAL_MS);

    return () => clearInterval(interval);
  }, [isChecking, maintenanceState.isUnderMaintenance]);

  return {
    ...maintenanceState,
    isChecking,
  };
}
